module.exports = __webpack_public_path__ + "img/img-1-mobile.b4fae8bb.png";